var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.472 8.03597H10.5883C10.2069 8.03597 9.89062 7.71969 9.89062 7.3383C9.89062 6.9569 10.2069 6.64062 10.5883 6.64062H15.472C15.8534 6.64062 16.1697 6.9569 16.1697 7.3383C16.1697 7.71969 15.8627 8.03597 15.472 8.03597Z",
    fill: "#5D7285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71334 8.74386C5.53659 8.74386 5.35985 8.67874 5.22031 8.53921L4.52264 7.84153C4.25287 7.57177 4.25287 7.12525 4.52264 6.85549C4.79241 6.58572 5.23892 6.58572 5.50868 6.85549L5.71334 7.06014L7.31334 5.46014C7.5831 5.19037 8.02961 5.19037 8.29938 5.46014C8.56915 5.72991 8.56915 6.17642 8.29938 6.44618L6.20636 8.53921C6.07613 8.66944 5.89938 8.74386 5.71334 8.74386Z",
    fill: "#5D7285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.472 14.5438H10.5883C10.2069 14.5438 9.89062 14.2275 9.89062 13.8461C9.89062 13.4647 10.2069 13.1484 10.5883 13.1484H15.472C15.8534 13.1484 16.1697 13.4647 16.1697 13.8461C16.1697 14.2275 15.8627 14.5438 15.472 14.5438Z",
    fill: "#5D7285"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71334 15.2517C5.53659 15.2517 5.35985 15.1866 5.22031 15.047L4.52264 14.3493C4.25287 14.0796 4.25287 13.6331 4.52264 13.3633C4.79241 13.0935 5.23892 13.0935 5.50868 13.3633L5.71334 13.568L7.31334 11.968C7.5831 11.6982 8.02961 11.6982 8.29938 11.968C8.56915 12.2377 8.56915 12.6842 8.29938 12.954L6.20636 15.047C6.07613 15.1773 5.89938 15.2517 5.71334 15.2517Z",
    fill: "#5D7285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0407 20.25H7.4593C2.40814 20.25 0.25 18.0919 0.25 13.0407V7.4593C0.25 2.40814 2.40814 0.25 7.4593 0.25H13.0407C18.0919 0.25 20.25 2.40814 20.25 7.4593V13.0407C20.25 18.0919 18.0919 20.25 13.0407 20.25ZM7.4593 1.64535C3.17093 1.64535 1.64535 3.17093 1.64535 7.4593V13.0407C1.64535 17.3291 3.17093 18.8547 7.4593 18.8547H13.0407C17.3291 18.8547 18.8547 17.3291 18.8547 13.0407V7.4593C18.8547 3.17093 17.3291 1.64535 13.0407 1.64535H7.4593Z",
    fill: "#5D7285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskk);
export default __webpack_public_path__ + "static/media/taskk.24860f9582d4fc353bc5e31e0ecfff10.svg";
export { ForwardRef as ReactComponent };